import { isMobileView } from "@/screens/utils/getScreenSize";

/**
 * Returns the platform string for page view tracking.
 * - "app" when running inside the React Native WebView
 * - "web-mobile" when viewport is mobile-sized in a browser
 * - "web-desktop" otherwise
 */
export function getPlatform() {
  if (globalThis.ReactNativeWebView) {
    return "app";
  }
  if (isMobileView(globalThis.innerWidth)) {
    return "web-mobile";
  }
  return "web-desktop";
}
